import { useRef, useEffect } from "react";
import AlarmSoundShort from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/sounds/alarm-short.mp3";
import { clampAudioVolume, resolveEffectiveVolume } from "utils/audioMixer";
import { AUDIO_PLAYBACK_UNLOCKED_EVENT } from "utils/audioPlaybackEvents";
import { attachGlobalAlertAudio } from "utils/globalAlertAudio";

// Optional: toast fallback
const showAudioBlockedToast = () => {
  alert("🔕 Your browser blocked the sound. Click anywhere to re-enable."); // Replace with your toast/Toastr/etc.
};

const fallbackPlayAudio = async (src, volume = 1.0) => {
  try {
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const response = await fetch(src);
    const buffer = await response.arrayBuffer();
    const decoded = await context.decodeAudioData(buffer);
    const source = context.createBufferSource();
    const gainNode = context.createGain();
    const clampedVolume = clampAudioVolume(volume, 1);
    gainNode.gain.value = clampedVolume;
    source.buffer = decoded;
    source.connect(gainNode);
    gainNode.connect(context.destination);
    source.start(0);
    console.log("✅ Played audio using Web Audio API fallback");
  } catch (e) {
    console.warn("❌ Web Audio API fallback failed:", e);
    showAudioBlockedToast();
  }
};

const GlobalAudio = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const controller = attachGlobalAlertAudio(audioRef.current, {
      fallbackPlay: fallbackPlayAudio,
    });

    window.playGlobalAudio = (src, volumeOrOptions = 1.0) => {
      if (!src) return;

      if (!sessionStorage.getItem("audioUnlocked")) {
        console.warn("🔒 Audio not unlocked, skipping play.");
        return;
      }

      if (!audioRef.current) {
        console.warn("🎧 No audio ref available");
        return;
      }

      const clampedVolume = typeof volumeOrOptions === "object"
        ? resolveEffectiveVolume(volumeOrOptions)
        : clampAudioVolume(volumeOrOptions, 1);

      controller.play(src, clampedVolume);
    };

    window.stopGlobalAudio = () => {
      controller.stop();
    };

    let dummyAudio = null;
    window.unlockAudioPlayback = () => {
      console.log("🔈 Running unlockAudioPlayback");

      dummyAudio = new Audio(AlarmSoundShort);
      dummyAudio.muted = true;

      dummyAudio
        .play()
        .then(() => {
          sessionStorage.setItem("audioUnlocked", "true");
          window.dispatchEvent(new Event(AUDIO_PLAYBACK_UNLOCKED_EVENT));
          console.log("✅ Audio unlocked for this session");
        })
        .catch((e) => {
          console.warn("❌ Autoplay unlock failed:", e.message);
        });
    };

    return () => {
      controller.dispose();
      if (window.playGlobalAudio) {
        delete window.playGlobalAudio;
      }
      if (window.stopGlobalAudio) {
        delete window.stopGlobalAudio;
      }
      if (window.unlockAudioPlayback) {
        delete window.unlockAudioPlayback;
      }
    };
  }, []);

  return <audio ref={audioRef} preload="auto" />;
};

export default GlobalAudio;
